import Table from './_table';
import TableColumn from './table-column';

Table.TableColumn = TableColumn;

export default Table;
